import { createStore, compose, applyMiddleware } from 'redux';
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';
import thunkMiddleware from 'redux-thunk';
import { middleware as NotificationMiddleware } from 'react-redux-notifications';

// import the root reducer
import rootReducer from './reducers/index';

console.log(" GETTING HERE 1 ");

const configureStore = () => {
	const enhancers = compose(
		window.devToolsExtension ? window.devToolsExtension() : f => f
	);

	const reduxRouterMiddleware = routerMiddleware(browserHistory);

	let createStoreWithMiddleware = applyMiddleware(
		thunkMiddleware,
		reduxRouterMiddleware
	)(createStore);

	const store = createStoreWithMiddleware(rootReducer, enhancers);


	if (module.hot) {
		module.hot.accept('./reducers/', () => {
			const nextRootReducer = require('./reducers/index').default;
			store.replaceReducer(nextRootReducer);
		});
	}

	return store;
}

export default configureStore;



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/